const PREFIX = 'notifications:push-prompt:'

/** localStorage key of the per-account flag; its `storage` event reaches other tabs. */
export const pushPromptKey = (userId: string) => `${PREFIX}${userId}`

/** Tabs that show the offer tell the others on this channel. */
export const PUSH_PROMPT_CHANNEL = 'arena:push-prompt'

/**
 * BAT-980: the offer is shown once per account. The server keeps the record
 * (`prompted_at`); this is its cache in the browser, so a known answer costs
 * no request.
 */
export function wasPushPrompted(userId: string): boolean {
  try {
    return window.localStorage.getItem(pushPromptKey(userId)) !== null
  } catch {
    // Blocked storage: better never to nag than to show it on every load.
    return true
  }
}

/** Shown, or the fan chose in the profile: no automatic offer after that. */
export function rememberPushPrompted(userId: string): void {
  try {
    window.localStorage.setItem(pushPromptKey(userId), new Date().toISOString())
  } catch {
    // Nothing to do: wasPushPrompted already answers "yes" without storage.
  }
}

/** The offer could not be shown after all: it may be offered again. */
export function forgetPushPrompted(userId: string): void {
  try {
    window.localStorage.removeItem(pushPromptKey(userId))
  } catch {
    // Nothing to do.
  }
}
